import { c as _c } from "react/compiler-runtime";
import { getDaysInMonth, isEqual, isValid, set } from 'date-fns';
import type React from 'react';
import { useEffect, useRef, useState } from 'react';
import Text from '../../../text';
type DateInputProps = {
  autoFocus?: boolean;
  value: Date;
  hasError?: boolean;
  onChange: (date: Date) => void;
  onFocus: () => void;
};
const DateInput = t0 => {
  const $ = _c(54);
  const {
    autoFocus,
    value,
    hasError,
    onChange,
    onFocus
  } = t0;
  const [focused, setFocused] = useState(false);
  let t1;
  if ($[0] !== value) {
    t1 = () => (value.getMonth() + 1).toString().padStart(2, "0");
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [month, setMonth] = useState(t1);
  let t2;
  if ($[2] !== value) {
    t2 = () => value.getDate().toString().padStart(2, "0");
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [day, setDay] = useState(t2);
  let t3;
  if ($[4] !== value) {
    t3 = value.getFullYear().toString();
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [year, setYear] = useState(t3);
  const monthRef = useRef(null);
  const dayRef = useRef(null);
  const yearRef = useRef(null);
  const containerRef = useRef(null);
  let t4;
  let t5;
  if ($[6] !== value) {
    t4 = () => {
      setMonth((value.getMonth() + 1).toString().padStart(2, "0"));
      setDay(value.getDate().toString().padStart(2, "0"));
      setYear(value.getFullYear().toString());
    };
    t5 = [value];
    $[6] = value;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] !== day || $[10] !== month || $[11] !== onChange || $[12] !== value || $[13] !== year) {
    t6 = () => {
      const newDate = set(value, {
        year: Number.parseInt(year, 10),
        month: Number.parseInt(month, 10) - 1,
        date: Number.parseInt(day, 10)
      });
      if (!isValid(newDate)) {
        setMonth((value.getMonth() + 1).toString().padStart(2, "0"));
        setDay(value.getDate().toString().padStart(2, "0"));
        setYear(value.getFullYear().toString());
      }
      if (!isEqual(newDate, value)) {
        onChange(newDate);
      }
    };
    $[9] = day;
    $[10] = month;
    $[11] = onChange;
    $[12] = value;
    $[13] = year;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const submit = t6;
  const getMaxDaysForMonth = _temp;
  let t7;
  if ($[15] !== onFocus) {
    t7 = event => {
      event.currentTarget.select();
      setFocused(true);
      onFocus();
    };
    $[15] = onFocus;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const handleFocus = t7;
  let t8;
  if ($[17] !== day || $[18] !== month || $[19] !== submit || $[20] !== year) {
    t8 = () => {
      setFocused(false);
      let monthValue_0 = Number.parseInt(month, 10);
      monthValue_0 = Math.max(1, Math.min(12, monthValue_0));
      setMonth(monthValue_0.toString().padStart(2, "0"));
      const yearValue_0 = Number.parseInt(year, 10);
      const maxDays = getMaxDaysForMonth(monthValue_0, yearValue_0);
      let dateValue = Number.parseInt(day, 10);
      dateValue = Math.max(1, Math.min(maxDays, dateValue));
      setDay(dateValue.toString().padStart(2, "0"));
      if (year.length > 0) {
        if (yearValue_0 > 0) {
          setYear(yearValue_0.toString());
        }
      }
      submit();
    };
    $[17] = day;
    $[18] = month;
    $[19] = submit;
    $[20] = year;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const handleBlur = t8;
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = event_0 => {
      const monthValue_1 = event_0.target.value;
      if (monthValue_1 === "" || /^[0-9]{1,2}$/.test(monthValue_1)) {
        const numMonth = Number.parseInt(monthValue_1, 10);
        if (numMonth > 12) {
          setMonth("12");
        } else {
          setMonth(monthValue_1);
        }
      }
    };
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const handleMonthChange = t9;
  let t10;
  if ($[23] !== month || $[24] !== year) {
    t10 = event_1 => {
      const dateValue_0 = event_1.target.value;
      if (dateValue_0 === "" || /^[0-9]{1,2}$/.test(dateValue_0)) {
        const numDate = Number.parseInt(dateValue_0, 10);
        const numMonth_0 = Number.parseInt(month, 10);
        const numYear = Number.parseInt(year, 10);
        const maxDays_0 = getMaxDaysForMonth(numMonth_0, numYear);
        if (numDate > maxDays_0) {
          setDay(maxDays_0.toString());
        } else {
          setDay(dateValue_0);
        }
      }
    };
    $[23] = month;
    $[24] = year;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const handleDateChange = t10;
  let t11;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = event_2 => {
      const yearValue_1 = event_2.target.value;
      if (yearValue_1 === "" || /^[0-9]{1,4}$/.test(yearValue_1)) {
        setYear(yearValue_1);
      }
    };
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const handleYearChange = t11;
  let t12;
  if ($[27] !== submit) {
    t12 = event_3 => {
      if (event_3.key === "Enter") {
        submit();
      }
      if (event_3.key === "Tab") {
        event_3.preventDefault();
        if (event_3.currentTarget === monthRef.current) {
          dayRef.current?.focus();
        } else {
          if (event_3.currentTarget === dayRef.current) {
            yearRef.current?.focus();
          } else {
            if (event_3.currentTarget === yearRef.current) {
              containerRef.current?.blur();
            }
          }
        }
      }
    };
    $[27] = submit;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const handleKeyDown = t12;
  let t13;
  if ($[29] !== autoFocus || $[30] !== handleBlur || $[31] !== handleFocus || $[32] !== handleKeyDown || $[33] !== month) {
    t13 = <input className="fp-date-input-field text-body-2 w-6" ref={monthRef} autoFocus={autoFocus} maxLength={2} onBlur={handleBlur} onChange={handleMonthChange} onFocus={handleFocus} onKeyDown={handleKeyDown} type="number" value={month} />;
    $[29] = autoFocus;
    $[30] = handleBlur;
    $[31] = handleFocus;
    $[32] = handleKeyDown;
    $[33] = month;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Text color="tertiary" variant="body-2">/</Text>;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== day || $[37] !== handleBlur || $[38] !== handleDateChange || $[39] !== handleFocus || $[40] !== handleKeyDown) {
    t15 = <input className="fp-date-input-field text-body-2 w-6" ref={dayRef} maxLength={2} onBlur={handleBlur} onChange={handleDateChange} onFocus={handleFocus} onKeyDown={handleKeyDown} type="number" value={day} />;
    $[36] = day;
    $[37] = handleBlur;
    $[38] = handleDateChange;
    $[39] = handleFocus;
    $[40] = handleKeyDown;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Text color="tertiary" variant="body-2">/</Text>;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== handleBlur || $[44] !== handleFocus || $[45] !== handleKeyDown || $[46] !== year) {
    t17 = <input className="fp-date-input-field text-body-2 w-11" ref={yearRef} maxLength={4} onBlur={handleBlur} onChange={handleYearChange} onFocus={handleFocus} onKeyDown={handleKeyDown} type="number" value={year} />;
    $[43] = handleBlur;
    $[44] = handleFocus;
    $[45] = handleKeyDown;
    $[46] = year;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== focused || $[49] !== hasError || $[50] !== t13 || $[51] !== t15 || $[52] !== t17) {
    t18 = <div className="fp-date-input" ref={containerRef} data-focused={focused} data-error={hasError}>{t13}{t14}{t15}{t16}{t17}</div>;
    $[48] = focused;
    $[49] = hasError;
    $[50] = t13;
    $[51] = t15;
    $[52] = t17;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  return t18;
};
export default DateInput;
function _temp(monthValue, yearValue) {
  const date = new Date(yearValue, monthValue - 1, 1);
  return getDaysInMonth(date);
}